import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { ReactiveFormsModule } from '@angular/forms'
import { FlexLayoutModule } from '@angular/flex-layout'
import { MatInputModule } from '@angular/material/input'
import { MatButtonModule } from '@angular/material/button'
import { MatCheckboxModule } from '@angular/material/checkbox'
import { MatFormFieldModule } from '@angular/material/form-field'
import { ModalModule } from 'src/shared/modal'
import { PipesModule } from 'src/shared/pipes/pipes.module'
import { SelectSearchModule } from '../select-search/select-search.module'
import { ShipmentRatePickerService } from './shipment-rate-picker.service'
import { ShipmentRatePickerComponent } from './shipment-rate-picker.component'
import { FreightRatesListModule } from 'src/pages/admin/logistics/freight-rates/freight-rates-list/freight-rates-list.module'
import { FreightRatesLogOverlayModule } from 'src/pages/admin/logistics/freight-rates/log-overlay/freight-rates-log-overlay.module'
import { MatTabsModule } from '@angular/material/tabs'
import { MatRadioModule } from '@angular/material/radio'
import { ShipmentRatePathPickerComponent } from './shipment-rate-path-picker.component'
import { PathsListModule } from '../paths-list/paths-list.module'

@NgModule({
  declarations: [
    ShipmentRatePickerComponent,
    ShipmentRatePathPickerComponent,
  ],
  providers: [ShipmentRatePickerService],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    FreightRatesListModule,
    FreightRatesLogOverlayModule,
    MatButtonModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatInputModule,
    MatRadioModule,
    MatTabsModule,
    ModalModule,
    PipesModule,
    SelectSearchModule,
    PathsListModule,
  ],
})
export class ShipmentRatePickerModule { }
